const state = {
  // 原有状态
  user: null, // 用户信息
  loggedIn: false, // 登录状态
  permissions: [], // 权限列表

  // 新增状态
  token: localStorage.getItem('token') || '', // token
  loginLoading: false, // 登录加载状态
  registerLoading: false, // 注册加载状态

  // 愿望相关
  wishLoading: false,
  wishes: []  // 愿望列表
}

export default state
